import { render, staticRenderFns } from "./PdfUploaderModal.vue?vue&type=template&id=04ef58cb&scoped=true&"
import script from "./PdfUploaderModal.vue?vue&type=script&lang=js&"
export * from "./PdfUploaderModal.vue?vue&type=script&lang=js&"
import style0 from "./PdfUploaderModal.vue?vue&type=style&index=0&id=04ef58cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef58cb",
  null
  
)

export default component.exports